import script from "./valid.vue?vue&type=script&setup=true&lang=ts"
export * from "./valid.vue?vue&type=script&setup=true&lang=ts"

import "./valid.vue?vue&type=style&index=0&id=19c0067a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c0067a"]])

export default __exports__